// ----------------------------------------------------------------------------
// Section: Country Modal
// ----------------------------------------------------------------------------
//
// Country Modal Section
// - Based on the modal pattern
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import $ from 'jquery';

// Styles
import './_country-modal.scss';

/**
 * Country Modal Snippet Script
 * ------------------------------------------------------------------------------
 * A file that manage the country popup switcher when the user first comes to the website.
 * There will be no popup for returning users.
 */

var inIframe = function() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
};

// Checks if URL exists or goes to 404
const checkURL = async (url, relativePath) => {
    const redirectURL = url + relativePath;

    try {
        const response = await fetch(redirectURL);

        if (response.status === 404) {
            window.location = url;
        } else {
            window.location = redirectURL;
        }
    } catch (error) {
        console.error(`Error checking ${url}: ${error}`);
        window.location = redirectURL;
    }
}

// Country Switch Popup
var doLocale = function() {

    var countryMap = {
        'duer.ca'                  : 'CA',
        'dish-du-er.myshopify.com' : 'CA',
        'dishandduer.myshopify.com': 'US',
        'duer.com'             : 'US',
        'duerdevusd.iamotadev.com' : 'US',
        'duerdevusd.myshopify.com' : 'US',
        'duer-uk.myshopify.com'    : 'GBR',
        'shopduer.co.uk'           : 'GBR',
        'duereu.myshopify.com'     : 'EU',
        "shopduer.eu"              : 'EU'

    };

    var hostCountry = document.body.getAttribute('data-country') || countryMap[document.domain];

    // Default to US
    if (hostCountry === undefined) {
       // hostCountry = 'CA';
    }else {
        // Set CSS class on body
        $('body').addClass('country--'+hostCountry.toLowerCase());
    }



    // Don't show the modal if If we are inside the customizer.
    if (inIframe()) { return; }

    /**
     * Return Visitor!
     */
    if (localStorage.getItem('userCountry') !== null) {

        // if (localStorage.getItem('userCountry') != hostCountry) {

        //     $('#country-modal').addClass('js--isOpen');
        // }
    }

    /**
    * Show the modal if GeoIP2 fails to load or is blocked for security
    */
    else if (typeof geoip2 === 'undefined') {
        $('#modal_country-modal').addClass('modal--open');
    }

    /**
     * Newbie user!
     */
    else {
        // GeoIP fetched successfully
        var geoSuccess = function(location) {
            var geoCountryCode = location.country.iso_code;

            // assign country to localStorage.
            localStorage.setItem('geoCountry', geoCountryCode);

            // CHECK! Does geo country match host country?
            if (geoCountryCode !== hostCountry) {

                $('#modal_country-modal').addClass('modal--open');
            }
        };
        // GeoIP Failed, show popup always
        var geoError = function(err) {

            // Show modal if we cannot detect country.
            $('#modal_country-modal').addClass('modal--open');
            // console.log(err);
        };

        // Get location from geoip database
        (async () => {
            try {
                const data = await fetch('/browsing_context_suggestions.json')
                const dataJson = await data.json()
                const browserCountryCode = dataJson.detected_values.country?.handle
                
                if (browserCountryCode) {
                    geoSuccess({
                        country: {
                            iso_code: browserCountryCode
                        }
                    })
                } else {
                    geoError(error)
                }
            } catch (error) {
                geoError(error)
            }
        })()
        // geoip2.country(geoSuccess, geoError);
    }


    $('#modal_country-modal .modal__country-link, #modal_country-modal .modal__overlay').on('click', function(e){
        e.preventDefault();

        var linkCountry = $(this).attr('data-country');
        localStorage.setItem('userCountry', linkCountry);

        if (linkCountry == hostCountry) {
            $('#modal_country-modal').removeClass('modal--open');
            $('body').removeClass('noscroll');
        } else {
            const storeURL = $(this).attr('href');
            const relativePath = window.location.pathname;
            checkURL(storeURL, relativePath);
        }
    });

    $('#modal_country-modal .modal__overlay').on('click', function(e){
        e.preventDefault();
    });
};

doLocale();
